import { CancelToken } from 'axios';
import { axios } from './axios';
import { handleErrors } from './utils';

function request(endpoint, params = {}, requestOptions = {}) {
    const { headers: requestHeaders } = requestOptions;

    return new Promise((resolve, reject) => {
        axios
            .get(endpoint, {
                params,
                cancelToken: new CancelToken(() => {}),
                ...(requestHeaders ? { headers: requestHeaders } : {}),
            })
            .then(({ data }) => {
                resolve(data);
            })
            .catch(handleErrors(reject));
    });
}

/**
 * @param {object} [requestOptions]
 * @param {Record<string, string | number | boolean>} [requestOptions.headers] - e.g. new API pagination (`count`, `offset`)
 */
export function get(entity, params = {}, requestOptions = {}) {
    if (!entity) return Promise.reject('Entity is needed');
    // there is a problem when we cancel the request but the
    // request is because we need another page for the table
    // if (entityListTokenCancel) {
    //     entityListTokenCancel('cancel');
    // }
    return request(entity.endpoint, params, requestOptions);
}

export function count(entity, params = {}, requestOptions = {}) {
    if (!entity) return Promise.reject('Entity is needed');
    if (!entity.countEndpoint) {
        return Promise.reject('Entity countEndpoint is needed');
    }
    return request(entity.countEndpoint, params, requestOptions);
}
